import React, { useState, useEffect } from 'react'

import { XIcon } from '@heroicons/react/outline'
import Select from 'react-select'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import RecipesForm from '../RecipesForm/RecipesForm';
import 'react-tabs/style/react-tabs.css';

const PlansForm = ({ planDescription, setPlanDescription, planRecipeItems, setPlanRecipeItems, planCalories, setPlanCalories, ingredientsData, groceriesData, setIsOpen, options }) => {

    const [description, setDescription] = useState(planDescription || '');
    const [userData, setUserData] = useState({});
    const [recipeData, setRecipeData] = useState({});
    const [meal, setMeal] = useState(planRecipeItems || {});
    const [recipes, setRecipes] = useState(planRecipeItems.recipes || []);
    const [groceries, setGroceries] = useState(planRecipeItems.groceries || []);
    const [advancedGroceries, setAdvancedGroceries] = useState(planRecipeItems.recipes ? (planRecipeItems.recipes[0] ? planRecipeItems.recipes[0].recipeItems : []) : [] || []);
    const [advancedRecipe, setAdvancedRecipe] = useState([]);
    const [mealCalories, setMealCalories] = useState(0);
    const [mealCarbs, setMealCarbs] = useState(0);
    const [mealFats, setMealFats] = useState(0);
    const [mealProteins, setMealProteins] = useState(0);

    const [advancedMealCalories, setAdvancedMealCalories] = useState(0);
    const [advancedMealCarbs, setAdvancedMealCarbs] = useState(0);
    const [advancedMealFats, setAdvancedMealFats] = useState(0);
    const [advancedMealProteins, setAdvancedMealProteins] = useState(0);

    const [name, setName] = useState('');
    const [recipeItems, setRecipeItems] = useState(ingredientsData || []);
    const [id, setId] = useState(null);


    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (planRecipeItems && (planRecipeItems.recipes || planRecipeItems.groceries)) {
            if(isAdvanced(planRecipeItems)) {
                mapAdvancedMealItems(planRecipeItems)
            } else {
                mapMealItems(planRecipeItems)
            }
            
        }
    }, [])
    
    const isAdvanced = (plan) => {
        let advanced = false;
        if(plan.recipes) {
            plan.recipes.forEach(item => {
                if (item.isAdvanced) {
                    setName(item.name)
                    advanced = true;
                } 
            })
        }
        return advanced;
    }

    const handleEditMeasure = (value, ingredient, key) => {
        let items = meal;

        items.groceries = items.groceries.map((item, index) => {
            if (item === ingredient && index === key) {
                item.servingSize = Number(value);
            }
            return item;
        });

        items.recipes = items.recipes.map((item, index) => {
            if (item === ingredient && index === key) {
                item.servingSize = Number(value);
            }
            return item;
        });
        setMeal(items);
        setGroceries(items.groceries)
        setRecipes(items.recipes)
        mapMealItems(items, true)
    }

    const handleAdvancedEditMeasure = (value, ingredient, key) => {
        let ag = []
        advancedGroceries.forEach(grocery => ag.push({...grocery}))
        setAdvancedGroceries(ag)

        ag = ag.map((item, index) => {
            if (item.value === ingredient.value && index === key) {
                item.servingSize = Number(value);
            }
            return item;
        });

        let tempMeal = { recipes: [], groceries: ag }
        setAdvancedGroceries(ag)
        mapAdvancedMealItems(tempMeal)
    }

    const handleDeleteIngredient = (ingredient) => {
        let items = { ...meal };
        items.groceries = items.groceries.filter(item => item !== ingredient);
        items.recipes = items.recipes.filter(item => item !== ingredient);
        setGroceries(items.groceries)
        setRecipes(items.recipes)
        mapMealItems(items)
        return setMeal(items);
    }

    const handleAdvancedDeleteIngredient = (ingredient) => {
        let items = [...advancedGroceries]
        items = items.filter(item => item !== ingredient);
        let tempMeal = { recipes: [], groceries: items }
        setAdvancedGroceries(items)
        mapAdvancedMealItems(tempMeal)
    }


    const mapMealItems = (meal, shouldRecalculate) => {
        let calories = 0;
        let carbs = 0;
        let proteins = 0;
        let fats = 0;

        if (meal.calories && meal.carbs && meal.proteins && meal.fats && !shouldRecalculate) {
            calories += Number(meal.calories);
            carbs += Number(meal.carbs);
            proteins += Number(meal.proteins);
            fats += Number(meal.fats);
        } else {
            meal.groceries.forEach(item => {
                calories += Number(item.ingredient.calories) * (Number(item.servingSize) / 100);
                carbs += Number(item.ingredient.carbohydrates) * (Number(item.servingSize) / 100);
                proteins += Number(item.ingredient.proteins) * (Number(item.servingSize) / 100);
                fats += Number(item.ingredient.fats) * (Number(item.servingSize) / 100);
            })

            meal.recipes.forEach(item => {
                if (item.servingSize && item.actualSize) {
                    calories += Number(item.calories) * (item.servingSize / item.actualSize);
                    carbs += Number(item.carbs) * (item.servingSize / item.actualSize);
                    proteins += Number(item.proteins) * (item.servingSize / item.actualSize);
                    fats += Number(item.fats) * (item.servingSize / item.actualSize);
                } else {
                    calories += Number(item.calories);
                    carbs += Number(item.carbs);
                    proteins += Number(item.proteins);
                    fats += Number(item.fats);
                }
            })
        }
        setMealCalories(Number(calories).toFixed(2))
        setMealCarbs(Number(carbs).toFixed(2))
        setMealProteins(Number(proteins).toFixed(2))
        setMealFats(Number(fats).toFixed(2))
    };

    const mapAdvancedMealItems = (meal) => {
        let calories = 0;
        let carbs = 0;
        let proteins = 0;
        let fats = 0;

        if (meal.calories && meal.carbs && meal.proteins && meal.fats) {
            calories += Number(meal.calories);
            carbs += Number(meal.carbs);
            proteins += Number(meal.proteins);
            fats += Number(meal.fats);
        } else {
            meal.groceries.forEach(item => {
                calories += Number(item.ingredient.calories) * (Number(item.servingSize) / 100);
                carbs += Number(item.ingredient.carbohydrates) * (Number(item.servingSize) / 100);
                proteins += Number(item.ingredient.proteins) * (Number(item.servingSize) / 100);
                fats += Number(item.ingredient.fats) * (Number(item.servingSize) / 100);
            })

            meal.recipes.forEach(item => {
                if (item.servingSize && item.actualSize) {
                    calories += Number(item.calories) * (item.servingSize / item.actualSize);
                    carbs += Number(item.carbs) * (item.servingSize / item.actualSize);
                    proteins += Number(item.proteins) * (item.servingSize / item.actualSize);
                    fats += Number(item.fats) * (item.servingSize / item.actualSize);
                } else {
                    calories += Number(item.calories);
                    carbs += Number(item.carbs);
                    proteins += Number(item.proteins);
                    fats += Number(item.fats);
                }
                if(item.isAdvanced) {
                    setName(item.name)
                    setDescription(item.description)
                }
            })
        }
        setAdvancedMealCalories(Number(calories).toFixed(2))
        setAdvancedMealCarbs(Number(carbs).toFixed(2))
        setAdvancedMealProteins(Number(proteins).toFixed(2))
        setAdvancedMealFats(Number(fats).toFixed(2))
    }

    const handleRecipeChange = (item) => {
        let temp = { recipes: [...recipes], groceries: [...groceries] }
        item.servingSize = item.actualSize
        let tempItem = { ...item }
        if (item.recipeItems) {
            setRecipes([...recipes, tempItem])
            if (temp.recipes) {
                temp.recipes.push(tempItem)
            } else {
                temp["recipes"] = [tempItem]
            }
        } else {
            setGroceries([...groceries, tempItem])
            if (temp.groceries) {
                temp.groceries.push(tempItem)
            } else {
                temp["groceries"] = [tempItem]
            }
        }
        mapMealItems(temp)
        return setMeal(temp);
    }

    const isNullOrWhitespace = value => {
        if (!value || value.trim() === '') {
            return true;
        }
        return false;
    }

    const handleAdvancedChangeSelection = (item) => {
        let temp = { recipes: [...recipes], groceries: [...groceries] }
        item.servingSize = item.actualSize
        let tempItem = { ...item }
        if (item.recipeItems) {
            setDescription(tempItem.description);
            setName(tempItem.name);

            let ag = [...item.recipeItems]
            let tempRecipe = { name: tempItem.name, value: tempItem.name, label: tempItem.name, description: tempItem.description, recipeItems: ag }

            tempRecipe = mapRecipeCals(tempRecipe);
            ag = [...tempRecipe.recipeItems]
            setAdvancedRecipe(tempRecipe)
            setAdvancedGroceries(ag)
        } else {
            setAdvancedGroceries([...advancedGroceries, tempItem])
            if (temp.groceries) {
                temp.groceries.push(tempItem)
            } else {
                temp["groceries"] = [tempItem]
            }
        }
        mapAdvancedMealItems(temp)
    }

    const handleFormSubmit = e => {
        e.preventDefault();
        if (meal.recipes && meal.groceries && meal.recipes.length === 0 && meal.groceries.length === 0) {
            setHasError(true);

        } else {
            setIsOpen(false);
            setPlanRecipeItems(meal)
        }
    }

    const handleAdvancedFormSubmit = e => {
        let indexOf = indexOfRecipe(recipes, name)
        if(indexOf > -1) {
            recipes.splice(indexOf, 1)
        }
        let temp = { recipes: [...recipes], groceries: [...groceries] }
        let tempRecipe = { name: name, value: name, label: name, description: description, recipeItems: advancedGroceries }
        tempRecipe = mapRecipeCals(tempRecipe);
        tempRecipe.isAdvanced = true

        setRecipes([...recipes, tempRecipe])
        if (temp.recipes) {
            temp.recipes.push({ ...tempRecipe })
        } else {
            temp["recipes"] = [{ ...tempRecipe }]
        }
        setIsOpen(false);
        setMeal({ ...temp });
        setPlanRecipeItems({ ...temp })
    }

    const indexOfRecipe = (recipes, name) => {
        let indexOf = -1;
        recipes.forEach(item => {
            if(item.name == name) {
                indexOf = recipes.indexOf(item)
            }
        })
        return indexOf;
    }

    const mapRecipeCals = (recipe) => {
        let calories = 0;
        let carbs = 0;
        let proteins = 0;
        let fats = 0;
        let actualSize = 0;
        recipe.recipeItems.forEach(item => {
            calories += Number(item.ingredient.calories) * (Number(item.servingSize) / 100);
            carbs += Number(item.ingredient.carbohydrates) * (Number(item.servingSize) / 100);
            proteins += Number(item.ingredient.proteins) * (Number(item.servingSize) / 100);
            fats += Number(item.ingredient.fats) * (Number(item.servingSize) / 100);
            actualSize += Number(item.servingSize);
        })

        return {
            ...recipe,
            calories: Number(calories).toFixed(2),
            carbs: Number(carbs).toFixed(2),
            proteins: Number(proteins).toFixed(2),
            fats: Number(fats).toFixed(2),
            actualSize: Number(actualSize),
            servingSize: Number(actualSize),
        };
    }



    const mapItems = (item, key) => (
        <div className="relative flex items-center mt-3 p-2 pr-4 bg-bluePrimary bg-opacity-10 rounded" key={key}>
            <span key={key}>{item.value}</span>
            <div className='relative  ml-auto'>
                <input type="number" placeholder="Measure" value={item.servingSize} onChange={(e) => handleEditMeasure(e.target.value, item, key)} className="input-field w-24 pl-2 pr-4 placeholder:text-xs" />
                <span className='absolute right-1.5 top-1/2 transform -translate-y-1/2 text-sm text-gray-800 '>g</span>
            </div>
            <span onClick={() => handleDeleteIngredient(item)} className="absolute top-0 right-0 flex items-center justify-center transform -translate-y-1/2 translate-x-1/2 w-4 h-4 border border-red-700 bg-white rounded-full  cursor-pointer">
                <XIcon className='text-red-800 w-3 h-3' />
            </span>
        </div>
    );

    const mapAdvancedItems = (item, key) => (
        <div className="relative flex items-center mt-3 p-2 pr-4 bg-bluePrimary bg-opacity-10 rounded" key={key}>
            <span key={key}>{item.value}</span>
            <div className='relative  ml-auto'>
                <input type="number" placeholder="Measure" value={item.servingSize} onChange={(e) => handleAdvancedEditMeasure(e.target.value, item, key)} className="input-field w-24 pl-2 pr-4 placeholder:text-xs" />
                <span className='absolute right-1.5 top-1/2 transform -translate-y-1/2 text-sm text-gray-800 '>g</span>
            </div>
            <span onClick={() => handleAdvancedDeleteIngredient(item)} className="absolute top-0 right-0 flex items-center justify-center transform -translate-y-1/2 translate-x-1/2 w-4 h-4 border border-red-700 bg-white rounded-full  cursor-pointer">
                <XIcon className='text-red-800 w-3 h-3' />
            </span>
        </div>
    );

    return (
        <>
            <h3 className='text-center py-2 bg-bluePrimary text-white shadow-md font-medium '>Dnevni plan</h3>
            <form className="plans-form w-full mt-6 min-h-[400px]  px-4">
                <Tabs>
                    <TabList>
                        <Tab>Standardno</Tab>
                        <Tab>Napredno</Tab>
                    </TabList>

                    <TabPanel className="pt-4">
                        <div className="relative pb-6 ">
                            <label className="font-medium text-xs text-gray-500">Recepti</label>
                            <Select
                                placeholder="Pretraži..."
                                onChange={(item) => handleRecipeChange(item)}
                                options={options}
                                classNamePrefix='select'
                            />
                            {hasError && ((meal.recipes && meal.groceries) && (meal.recipes.length === 0 || meal.groceries.length === 0)) &&
                                <span className="input-error">Unesite recept.</span>}
                        </div>
                        {recipes.map(mapItems)}
                        {groceries.map(mapItems)}

                        <p className="font-medium mt-5">Ukupno kalorija - {Number(mealCalories).toFixed(2)}</p>
                        <p className="font-medium mt-1">Ukupno proteina - {Number(mealProteins).toFixed(2)}</p>
                        <p className="font-medium mt-1">Ukupno ugljenih hidrata - {Number(mealCarbs).toFixed(2)}</p>
                        <p className="font-medium mt-1">Ukupno masti - {Number(mealFats).toFixed(2)}</p>
                        <button type="submit" className="button without-icon bg-secondaryGradient mx-auto mt-5" onClick={e => handleFormSubmit(e)}>
                            Sačuvaj
                        </button>
                    </TabPanel>
                    <TabPanel>
                        <div className="input-group">
                            <label className="font-medium text-xs text-gray-500">Naziv</label>
                            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-field" />
                            {hasError && isNullOrWhitespace(name) && <span className="input-error">Unesite ime recepta.</span>}
                            {hasError}
                        </div>
                        <div className="relative mt-5">
                            <label className="font-medium text-xs text-gray-500">Recepti</label>
                            <Select
                                placeholder={'Ukucajte da biste pretražili...'}
                                onChange={(item) => handleAdvancedChangeSelection(item)}
                                options={options}
                                classNamePrefix='select'
                            />
                            {advancedGroceries.map(mapAdvancedItems)}
                            <p className="font-medium mt-5">Ukupno kalorija - {Number(advancedMealCalories).toFixed(2)}</p>
                            <p className="font-medium mt-1">Ukupno proteina - {Number(advancedMealProteins).toFixed(2)}</p>
                            <p className="font-medium mt-1">Ukupno ugljenih hidrata - {Number(advancedMealCarbs).toFixed(2)}</p>
                            <p className="font-medium mt-1">Ukupno masti - {Number(advancedMealFats).toFixed(2)}</p>
                            {hasError && (recipeItems.length === 0) &&
                                <span className="input-error">Unesite namirnicu</span>}
                        </div>

                        <div className="input-group mt-5">
                            <label className="font-medium text-xs text-gray-500">Opis</label>
                            <textarea value={description} onChange={(e) => setDescription(e.target.value)} className="input-field h-52" >
                            </textarea>
                            {hasError && isNullOrWhitespace(description) && <span className="input-error">Unesite opis recepta</span>}
                        </div>

                        <button type="submit" disabled style={{ display: "none" }} aria-hidden="true"></button>
                        <button type="submit" className="button without-icon bg-secondaryGradient mx-auto mt-5" onClick={e => handleAdvancedFormSubmit(e)}>
                            Sačuvaj
                        </button>
                    </TabPanel>
                </Tabs>

            </form>
        </>
    )
}
export default PlansForm;


